// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { createListenerMiddleware } from '@reduxjs/toolkit';
import { userSlice } from '@shared/data-access/slices/user';
import { aiApi } from '@shared/data-access/api-base/citec-ai-api';
import {
  brokerageApi,
  brokerageApiV2,
  BrokerageTagTypes,
} from '@shared/data-access/api-base/citec-brokerage-api';
import {
  engineApi,
  engineApiV2,
} from '@shared/data-access/api-base/citec-engine-api';
import { SharedTagTypes } from '@shared/data-access/utils/constants';
import { onboardingApi } from '../api/engine/onboarding-api';

export const apiCacheSyncMiddleware = createListenerMiddleware();

apiCacheSyncMiddleware.startListening({
  actionCreator: userSlice.actions.setCurrency,
  effect: async (_, { dispatch }) => {
    dispatch(aiApi.util.invalidateTags([SharedTagTypes.CurrencyConversion]));

    dispatch(brokerageApi.util.invalidateTags([SharedTagTypes.CurrencyConversion]));

    dispatch(
      brokerageApiV2.util.invalidateTags([SharedTagTypes.CurrencyConversion]),
    );

    dispatch(engineApi.util.invalidateTags([SharedTagTypes.CurrencyConversion]));

    dispatch(engineApiV2.util.invalidateTags([SharedTagTypes.CurrencyConversion]));
  },
});

apiCacheSyncMiddleware.startListening({
  matcher: onboardingApi.endpoints.updateClientOnboardingProfile.matchFulfilled,
  effect: async (action, { dispatch }) => {
    const { submit_to_inversis } = action.meta.arg.originalArgs;

    if (!submit_to_inversis) {
      return;
    }

    dispatch(
      brokerageApiV2.util.invalidateTags([
        BrokerageTagTypes.Institution,
        BrokerageTagTypes.Client,
      ]),
    );
  },
});
